import styles from "./ParameterApplyModalContent.module.css";
import modal from "components/Modal/ModalContent.module.css";
import cn from "classnames";
import { Button } from "components/Button/Button";
import { IconButton } from "components/Button/IconButton";
import { IconCross } from "components/Icons/IconCross";
import { Notification } from "components/Notification";

import type { ActiveContext } from "shared/ContextSwitcher/store";

interface Props {
  activeContext: ActiveContext;

  cost: number;
  queryCount: number;
  unexecutableQueryCount: number;
  runAllQueries: () => void;

  close: () => void;
}

export function RunDashboardModalContent(props: Props) {
  const { activeContext, cost, queryCount, unexecutableQueryCount } = props;

  return (
    <div className={cn(modal.body)}>
      <div className={modal.header}>
        <div className={modal.titleRow}>
          <h2>
            Run all {queryCount}
            {unexecutableQueryCount > 0 ? " executable* " : " "}queries for this
            dashboard
          </h2>

          <IconButton size="XS" theme="ghost" onClick={props.close}>
            <IconCross />
          </IconButton>
        </div>
      </div>

      <div className={styles.content}>
        {unexecutableQueryCount > 0 && (
          <Notification
            level="warning"
            dismissable={false}
            title="*Deprecated datasets"
            description={
              <>
                {unexecutableQueryCount} queries on this dashboard can no longer
                be executed because they run against deprecated datasets.
              </>
            }
          />
        )}
        {activeContext.serviceTier.version === "v2" ? (
          <Notification
            level="info"
            dismissable={false}
            title={
              <>
                These executions will use {cost} credits from @
                {activeContext.name} plan quota.
              </>
            }
          />
        ) : (
          <Notification
            dismissable={false}
            level="info"
            title={
              <>
                These queries will be executed on your @{activeContext.name}{" "}
                plan quota.
              </>
            }
          />
        )}
      </div>

      <div className={modal.buttons}>
        <Button size="M" theme="tertiary" onClick={props.close}>
          Cancel
        </Button>

        <Button
          size="M"
          theme="primary"
          autoFocus
          onClick={() => {
            props.runAllQueries();
            props.close();
          }}
        >
          Run all queries
        </Button>
      </div>
    </div>
  );
}
